import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class LhcVariantMhd extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = event.detail.data.html.querySelector('lhc-variant-mhd');
    if (!next) return;

    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('lhc-variant-mhd')) {
  customElements.define('lhc-variant-mhd', LhcVariantMhd);
}
